import { EGameStatus } from '@lbs/shared-rp-types'
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto'
import AutorenewIcon from '@mui/icons-material/Autorenew'
import { UpdateRpGamePayload } from 'prp2boxApi/games'
import { FC } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { queryKeys } from '../../constants/EQueryKeysConstant'
import { Prp2boxApiGames } from '../../prp2boxApi'
import { CrudIconBtn, WrapDrawerEditForm } from '../index'
import RpGameFormBase from './base'
import { TRpGameFormData } from './schema'
import { useRpGameForm } from './useRpGameForm'

type TRpGameFormEditProps = {
  id: string
}

const RpGameFormEdit: FC<TRpGameFormEditProps> = ({ id }) => {
  const queryClient = useQueryClient()
  const hookForm = useRpGameForm()

  const gameId = Number(id)

  const { data: entity } = useQuery(queryKeys.rpGames.byId(gameId), () => Prp2boxApiGames.getById(gameId), {
    onSuccess: (data) => {
      hookForm.reset({
        name: data.name,
        status: data.status,
        dealer: data.dealer.id,
        player: data.player.id,
        limit: data.limit.id,
        stand: data.stand.id,
        bonus: data.bonus.id,
        payout: data.payout.id,
      })
    },
    refetchOnWindowFocus: false,
  })

  const updateMutation = useMutation((payload: UpdateRpGamePayload) => Prp2boxApiGames.update(gameId, payload), {
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.rpGames.base })

      toast.success('Игра успешно обновлена')
    },
  })

  const finishMutation = useMutation(() => Prp2boxApiGames.finish(gameId), {
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.rpGames.base })

      toast.success('Игра успешно завершена')
    },
  })

  const handleSave = (data: TRpGameFormData) => {
    const {
      name,
      status,
      dealer: dealerId,
      player: playerId,
      limit: limitId,
      stand: standId,
      bonus: bonusId,
      payout: payoutId,
    } = data

    updateMutation.mutate({
      name,
      status,
      dealerId,
      playerId,
      limitId,
      standId,
      bonusId,
      payoutId,
    })
  }

  return (
    <WrapDrawerEditForm
      title={`Редактирование RpGame ${entity?.name || ''}`}
      onSave={hookForm.handleSubmit(handleSave)}
      isShowSaveBtn
      isShowEditBtn={false}
      isShowDeleteBtn={false}
      isShowBlockBtn={false}
      busyText=""
      isBusy={false}
      additionalButtons={
        <div>
          {entity?.status && [EGameStatus.ACTIVE, EGameStatus.CREATED].includes(entity.status) && (
            <CrudIconBtn
              tooltip="Завершить игру"
              color="success"
              icon={<AssistantPhotoIcon />}
              onClick={finishMutation.mutate}
            />
          )}
          {entity?.status && entity.status === EGameStatus.ACTIVE && (
            <CrudIconBtn
              tooltip="Перезапустить текущую сессию"
              color="warning"
              icon={<AutorenewIcon />}
              onClick={async () => {
                try {
                  await Prp2boxApiGames.forceRestartSession(gameId)
                  toast.success('Сессия успешно перезапущена')
                } catch (e) {
                  toast.error('Ошибка при перезапуске сессии')
                }
              }}
            />
          )}
        </div>
      }>
      <RpGameFormBase hookForm={hookForm} />
    </WrapDrawerEditForm>
  )
}

export default RpGameFormEdit
